<template>
  <div
    :class="bindPackageClass"
    :style="pcBindContentStyle"
    v-if="isRenderAllTemp"
  >
    <div class="content" :style="bindContentStyle">
      <div class="title" :style="titleColor">
        <span v-html="uidTitleMsg" />
        <MBPopover v-if="!isRenderEmail" :tipsImages="tipsImages" />
      </div>
      <template v-if="isRenderEmail">
        <EmailComp />
      </template>
      <!--Tips: UID + Zone ID -->
      <template v-else-if="isZoneIdInputGame">
        <ZoneIdUidComp />
      </template>
      <!--Tips: 斗罗、pns -->
      <template v-else-if="isParallelRequestsGame">
        <div class="parallel-games">
          <ServerUid />
          <SearchServerList />
        </div>
      </template>
      <template v-else-if="isNotExternalInputServerGames">
        <NotVerifiedUidServerTemp />
      </template>
      <template v-else-if="isRenderNotCheckUidTemp">
        <div class="external-uid-content">
          <DropdownMenuSearch v-if="serverList.length" />
          <NotVerifiedUidTemp />

          <!-- 只有一个UID的时候、需要展示第二次输入的状态 -->
          <!-- 如果出现serverID && userID的时候 那么就不展示 -->
          <template v-if="isNotCheckGames">
            <CheckUidTemp />
          </template>
        </div>
      </template>
      <div class="details-uid-con" v-else>
        <DropdownMenuSearch v-if="serverList.length" />
        <UidComp />
      </div>
      <ErrorTips />
      <NickName />
    </div>
  </div>
</template>
<script>
  import MBPopover from '@/components/MBPopover'
  import UidComp from './components/UidComp'
  import EmailComp from './components/EmailComp'
  import ServerUid from './components/ServerUid'
  import CheckUidTemp from './components/CheckUidTemp'
  import ZoneIdUidComp from './components/ZoneIdUidComp'
  import NotVerifiedUidTemp from './components/NotVerifiedUidTemp'
  import NotVerifiedUidServerTemp from './components/NotVerifiedUidServerTemp'
  import NickName from './components/NickName'
  import ErrorTips from './components/ErrorTips'
  import DropdownMenuSearch from './components/DropdownMenuSearch'
  import SearchServerList from './components/SearchServerList'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters } from 'vuex'

  export default {
    mixins: [styleConfiguration],
    props: {
      addClass: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    components: {
      MBPopover,
      UidComp,
      EmailComp,
      CheckUidTemp,
      NickName,
      ZoneIdUidComp,
      ErrorTips,
      ServerUid,
      DropdownMenuSearch,
      SearchServerList,
      NotVerifiedUidServerTemp,
      NotVerifiedUidTemp,
    },
    computed: {
      ...mapState(['gameName', 'region', 'isMobile', 'isApp', 'isDesktop']),
      ...mapState('detail', ['serverList']),
      ...mapGetters([
        'isKungfuLegend',
        'isRuStarMaker',
        'isZoneIdInputGame',
        'isParallelRequestsGame',
        'isNotExternalInputServerGames',
        'isNotCheckGames',
        'isNotExternalServerCheckGames',
        'isMySoulLand3d',
      ]),
      uidTitle() {
        if (this.uidModuleType === 6) {
          return this.$t('publicDetails.detail_email_title')
        }
        return this.$t(`publicDetails.uid_title`, {
          uid: 'UID',
        })
      },
      uidTitleMsg() {
        if (this.isKungfuLegend) {
          return this.$t(`publicDetails.uid_account_title`, {
            umn: '1.',
          })
        }

        if (this.isRuStarMaker) {
          return `1.&nbsp;${this.$t(`publicDetails.uid_title`, {
            uid: 'SID',
          })}`
        }
        if (this.isMySoulLand3d) {
          return `1.&nbsp;${this.$t(`${this.gameName}.uid_title`)}`
        }
        return `1. ${this.uidTitle}`
      },
      tipsImages() {
        return this.tipsImg
      },
      isRenderNotCheckUidTemp() {
        return this.isNotCheckGames || this.isNotExternalServerCheckGames
      },
      isRenderEmail() {
        return this.uidModuleType === 6
      },
      // PC端
      pcBindContentStyle() {
        if (this.isDesktop) {
          return this.bindContentStyle
        }
        return {
          backgroundColor: '',
        }
      },
      bindPackageClass() {
        const defaultClass = ['details-uid']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        if (this.addClass) {
          device.push(this.addClass)
        }
        return defaultClass.concat(device)
      },
      titleColor() {
        return this.mFontColor
      },
      bindContentStyle() {
        return this.moduleBackColor
      },

      // 是否渲染全部的模块
      isRenderAllTemp() {
        return this.awardType === 2 || this.uidModuleType === 6
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
